import React from "react";
import ReactDOM from "react-dom";
import App from "./App";

import { PrismicProvider } from "@prismicio/react";
import { client } from "./services/prismic";

import { QueryClient, QueryClientProvider } from "react-query";
import { ReactQueryDevtools } from "react-query/devtools";
const queryClient = new QueryClient();

ReactDOM.render(
  <QueryClientProvider client={queryClient}>
    <PrismicProvider client={client}>
      <App />
    </PrismicProvider>
    <ReactQueryDevtools initialIsOpen={false} />
  </QueryClientProvider>,
  document.getElementById("root")
);
